module.exports = __webpack_public_path__ + "img/logout-arrow.bfd90a5d.svg";